import * as React from 'react';
import * as ReactDom from 'react-dom';

import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";
import { ChatMessage } from "./ChatMessage";

import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';

import { escape, fromPairs } from '@microsoft/sp-lodash-subset';
import * as Fabric from 'office-ui-fabric-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import  * as uuidv4 from "uuid/v4";

import { getAuthenticatedClient } from "../../auth/authClient";
var graph = require('@microsoft/microsoft-graph-client');

/**
 * 
 * @param param0 props params is assigned to variables
 * {
 * @param teamId 
 * @param channelId 
 * @param context 
 * }
 */
export  function ChatMessagesContainer({chatId, accessToken, pageNumber}) {

    const [chatMessagesList, setChatMessagesList] = useState();
    const { dispatch, state } = useContext(MessagesContext);
    const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
    
    log.info(`@ChatMessagesContainer`);
    log.debug(`@ChatMessagesContainer accessToken: ${accessToken}`);

      React.useEffect(() => {    
        log.info(`useEffect @ ChatMessagesContainer`);
            getChatMessages(chatId, accessToken,pageNumber).then((msg) =>{
          });        
      }, []);
  
    
/**
 * const getMessages
 * Gets the mesages based on @microsoft/sp-http client
 * @param chatId 
 * @param accessToken
 * @param pageNumber
 */
      const getChatMessages = async (chatId, accessToken, pageNumber) =>{
      log.info(`getChatMessages @ ChatMessagesContainer`);
  

      // const options = {
      //   authProvider,
      // };
      
      // const client = Client.init(options);
      
      // let res = await client.api('/chats/{id}/messages')
      //   .version('beta')
      //   .get();


       const _top = state.numberOfItemsInPage;
       const _skip = _top*(pageNumber-1); 
       //const _order = `lastModifiedDateTime DESC`; 
        //const oDataQuery = `?$top=3&$skip=2`;
       const oDataQuery = ``;// not supported yet `?$top=${_top}&$skip=${_skip}`;//&$orderby=${_order}`;
       //const messagesUrl = `/teams/${teamId}/channels/${channelId}/messages${oDataQuery}`; //MESSAGES_URL;
       const chatMessagesUrl = `/chats/${chatId}/messages${oDataQuery}`; //MESSAGES_URL;
       const client = getAuthenticatedClient(accessToken);

       try {
        const res = await client
                .api(chatMessagesUrl)
                .headers({
                  "Content-Type" : "application/json;charset=UTF-8",
                   "mode": "cors",
                  "Access-Control-Allow-Origin" : '' 
                })
                .version('beta')
                .get((error, chatMessages, rawResponse) => {
    
                  //console.log('@getMessages >  selectedMessages ' + JSON.stringify(messages)); 
                    
                    if (chatMessages) {
                                          
                      let someChatMessages =    chatMessages.value.filter(chatMessage =>{                         
                        if (chatMessage.body.content.length > 0 ) return true;
                        return false;
                      });
    
                      const  selectedChatMessages =   someChatMessages.map(chatMessage => {
                          const _chatMessage = 
                          {
                              id :  chatMessage.id,
                              date: chatMessage.createdDateTime ? chatMessage.createdDateTime : `not availabe`,
                              text :  `[ChatMessage:] ${chatMessage.body.content}`,
                              webUrl : ``,//chatMessage.webUrl,
                              user : chatMessage.from.user.displayName,
                              type : "Message",
                              selected : false
                          };
                      return _chatMessage;
                      });
                    //console.log('@getMessages >  selectedMessages ' + JSON.stringify(selectedMessages));
                    const selectedChatMessagesReversed = [...selectedChatMessages];//.reverse() taken off  !!!!!!!!!!!!!!!
                    setChatMessagesList(selectedChatMessagesReversed); 
                    return selectedChatMessagesReversed;
    
                    } else {
                        return [];
                    }
                  }
                );         
       } catch (error) {
         log.error(`getChatMessages @ ChatMessagesContainer error: ${JSON.stringify(error)}`);
      } finally {
        log.info(`finally / getChatMessages @ ChatMessagesContainer`);
      }
     
    }
      
    const MyErrorComponent = ({error})=>{  
        log.error(`renderChatMessages @ ChatMessagesContainer error ${error.message}`);
      return (
          <div >Error. Search in Logs for details.</div>
      )
    }

    const renderChatMessages = ()=>{

      if (chatMessagesList == null || chatMessagesList == undefined ){
        return (
          <>  
          <Spinner size={SpinnerSize.large} />
          </> 
        )
      }
  
      const _chatMessagesList = chatMessagesList.map(chatMessage => (
        <ErrorBoundary  key={uuidv4()}
              render={() => 
                          <ChatMessage    
                                  chatId = {chatId}
                                  chatMessageId = {chatMessage.id}
                                  chatMessage = {chatMessage}
                                  accessToken = {accessToken}
                                  ></ChatMessage>
              }
              renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}
        >
        </ErrorBoundary>              
        )
      )
      return _chatMessagesList;
    }

    return (
    <>
      {renderChatMessages()}
    </>
    )
  }
  